var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZoomGesture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.93846 9.57951L7.76062 4.30689C7.68279 3.95826 7.7344 3.59322 7.90581 3.27982C8.07723 2.96642 8.35677 2.72605 8.69231 2.60351C8.88906 2.53176 9.09885 2.50282 9.30767 2.51862C9.51649 2.53443 9.71954 2.5946 9.90325 2.69514C10.087 2.79567 10.2471 2.93425 10.373 3.10161C10.4989 3.26898 10.5876 3.46127 10.6332 3.66566L11.7262 8.5592L12.0548 8.43982C12.3803 8.32081 12.7261 8.2671 13.0723 8.28175C13.4186 8.29639 13.7586 8.37911 14.0729 8.52518C14.3872 8.67124 14.6696 8.87779 14.9041 9.13303C15.1386 9.38827 15.3205 9.6872 15.4394 10.0127L16.5791 13.1352M8.93846 9.58812L7.00615 6.21582C6.82994 5.9097 6.55145 5.6755 6.21965 5.55439C5.88785 5.43329 5.52397 5.43303 5.192 5.55366C4.99183 5.6269 4.80959 5.74198 4.65742 5.89123C4.50525 6.04047 4.38665 6.22045 4.30954 6.41916C4.23244 6.61787 4.19859 6.83073 4.21026 7.04356C4.22193 7.25638 4.27886 7.46427 4.37723 7.65335L6.69846 12.1137L6.25538 12.3783C5.95305 12.5577 5.70031 12.8098 5.52012 13.1116C5.33993 13.4135 5.238 13.7556 5.22357 14.1069C5.20914 14.4581 5.28268 14.8075 5.43751 15.1231C5.59234 15.4387 5.82355 15.7107 6.11015 15.9143L6.408 16.1247L7.10338 16.6207M2.53846 0.873047L1 2.41151M1 2.41151L2.53846 3.94997M1 2.41151H4.69231M15.4615 0.873047L17 2.41151M17 2.41151L15.4615 3.94997M17 2.41151H13.3077",
    stroke: "#82CFFF",
    strokeWidth: 1.23077,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomGesture);
export default __webpack_public_path__ + "static/media/zoom_gesture.13d3b933225e8e08ae5894a5e3d51268.svg";
export { ForwardRef as ReactComponent };